export default __webpack_public_path__ + "icon-chevron.193424ce.png";